import { getSLAsFromTicket, getActiveSLAFromTicket, ticketIsPaused } from 'svh-tickets-lib/tickets/public/operators';
import { ActiveSLAAlert } from 'svh-onboarding-config-shared-lib/sla/components/ActiveSLAAlert';
import { SLADetailsTooltip } from 'svh-onboarding-config-shared-lib/sla/components/SLADetailsTooltip';
import { SLAPausedDetailsTooltip } from 'svh-onboarding-config-shared-lib/sla/components/SLAPausedDetailsTooltip';
import { PausedSLATag } from 'svh-onboarding-config-shared-lib/sla/components/PausedSLATag';
import { jsx as _jsx } from "react/jsx-runtime";
const SLATag = ({
  ticket,
  isPreviewPanel
}) => {
  const allSLAs = getSLAsFromTicket(ticket);
  const activeSLA = getActiveSLAFromTicket(ticket);
  const isPaused = ticketIsPaused(ticket);
  if (isPaused) {
    var _ticket$pipelineInfo;
    return /*#__PURE__*/_jsx(SLAPausedDetailsTooltip, {
      pausedTicketStatus: ticket === null || ticket === void 0 || (_ticket$pipelineInfo = ticket.pipelineInfo) === null || _ticket$pipelineInfo === void 0 || (_ticket$pipelineInfo = _ticket$pipelineInfo.currentStage) === null || _ticket$pipelineInfo === void 0 ? void 0 : _ticket$pipelineInfo.label,
      slas: allSLAs,
      ticketId: ticket.id,
      children: /*#__PURE__*/_jsx(PausedSLATag, {})
    });
  }
  if (!activeSLA) return null;
  return /*#__PURE__*/_jsx(SLADetailsTooltip, {
    slas: allSLAs,
    activeSLA: activeSLA,
    children: /*#__PURE__*/_jsx(ActiveSLAAlert, {
      activeSLA: activeSLA,
      isPreviewPanel: isPreviewPanel
    })
  });
};
SLATag.displayName = 'SLATag';
export default SLATag;